import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";
import { Column } from "@ant-design/plots";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { HomeCard } from "../../../../../components";
import { moneyFormat } from "../../../../../plugins/numberFormat";
import { useGetComissionOverview } from "../../hooks/comissionreport.hooks";
import styles from "./style.module.scss";
const ComissionOverview = () => {
  const { t } = useTranslation();
  const { data, isLoading, isError } = useGetComissionOverview({});
  const [chartData, setChartData] = useState([]);

  const config = {
    data: chartData,
    xField: "period_week",
    yField: "total_bonus",
    label: {
      // 可手动配置 label 数据标签位置
      position: "middle",
      // 'top', 'bottom', 'middle',
      // 配置样式
      style: {
        fill: "#FFFFFF",
        opacity: 0.6,
      },
    },
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
    },
    meta: {
      // period_month: {
      //   alias: "月份",
      // },
      period_week: {
        alias: "week",
      },
      total_bonus: {
        alias: t("mobile.comissionoverview.total_bonus"),
      },
    },
    maxColumnWidth: 50,
  };

  useEffect(() => {
    if (!!data && data.agent_bonus) {
      const formatData = [];
      const dateFormat = "MM/DD/YY";
      // eslint-disable-next-line array-callback-return
      data.agent_bonus.reverse().map((item) => {
        const startDate = dayjs(item.period_start_date).format(dateFormat);
        const endDate = dayjs(item.period_end_date).format(dateFormat);
        formatData.push({ ...item, period_week: `${startDate}-${endDate}` });
      });
      setChartData(formatData);
    }
  }, [data]);

  return (
    <HomeCard title={t("mobile.comission.overview.title")}>
      <div className={styles.bodyContainer}>
        <div className={styles.subTitle}>
          {/* {`${t("administrationCenter.overview.commisionRecord.current_month_total_bonus")}: `}
          <span className={styles.content}>
            {moneyFormat(data?.current_month_total_bonus || 0)}
          </span> */}
          {`${t("administrationCenter.overview.commisionRecord.current_week_total_bonus")}: `}
          <span className={styles.content}>{moneyFormat(data?.current_week_total_bonus || 0)}</span>
        </div>
        <div className={styles.subTitle}>
          {/* {`${t("administrationCenter.overview.commisionRecord.last_month_bonus_difference")}: `}
          <span
            className={`${styles.content} ${
              data?.last_month_bonus_difference >= 0 ? styles.redColor : styles.greenColor
            }`}
          >{`${data?.last_month_bonus_difference || 0}%`}</span>
          {data?.last_month_bonus_difference >= 0 ? (
            <CaretUpOutlined className={styles.redColor} />
          ) : (
            <CaretDownOutlined className={styles.greenColor} />
          )} */}
          {`${t("administrationCenter.overview.commisionRecord.last_week_bonus_difference")}: `}
          <span
            className={`${styles.content} ${
              data?.last_week_bonus_difference >= 0 ? styles.redColor : styles.greenColor
            }`}
          >{`${data?.last_week_bonus_difference || 0}%`}</span>
          {data?.last_week_bonus_difference >= 0 ? (
            <CaretUpOutlined className={styles.redColor} />
          ) : (
            <CaretDownOutlined className={styles.greenColor} />
          )}
        </div>
        <Column className={styles.chart} {...config} style={{ height: 350 }} />
      </div>
    </HomeCard>
  );
};

export default ComissionOverview;
